/** Thai strings for this area (English source text -> Thai). */
export const CREATOR: Record<string, string> = {
  /* ---- Creator: header & canvas ---- */
  /* ---- Creator: brushes ---- */
  'The page is full! The eraser still works: rub out a bit to make room.': 'หน้ากระดาษเต็มแล้ว! ยางลบยังใช้ได้ ลบบางส่วนออกเพื่อวาดต่อ',
  'The page is completely full. Undo or clear a bit first.': 'หน้ากระดาษเต็มจริงๆ แล้ว กดย้อนกลับหรือล้างบางส่วนก่อนนะ',
  Brushes: 'แปรง',
  Marker: 'ปากกาเมจิก',
  Crayon: 'สีเทียน',
  Spray: 'สเปรย์',
  Watercolour: 'สีน้ำ',
  'Broad nib': 'ปากกาหัวตัด',
  Pixel: 'พิกเซล',
  'Pixel picture {n}×{n}': 'รูปพิกเซล {n}×{n} ช่อง',
  'Pixel art: every dab fills one square. Pick how many squares the picture has:': 'พิกเซลอาร์ต: แตะทีละช่องสี่เหลี่ยม เลือกว่ารูปจะมีกี่ช่อง:',
  '← Back': '← กลับ',
  'Animated preview': 'ตัวอย่างแบบเคลื่อนไหว',
  'Draw Your Hero': 'วาดฮีโร่ของเธอ',
  'Create & Share': 'สร้างและแชร์',
  'Draw yourself as a legend!': 'วาดตัวเองให้เป็นตำนานไปเลย!',
  'Draw a monster, give it stats, then dare a friend.': 'วาดมอนสเตอร์ ใส่ค่าพลัง แล้วท้าเพื่อนมาสู้!',
  'draw here ✎ (facing right →)': 'วาดตรงนี้ ✎ (หันหน้าไปทางขวา →)',
  'draw here ✎ (facing right →, it turns to face the hero)': 'วาดตรงนี้ ✎ (หันหน้าไปทางขวา → เดี๋ยวมันจะหันไปหาฮีโร่เอง)',
  Preview: 'ตัวอย่าง',
  'Drawing area. Draw with mouse, finger or stylus.': 'พื้นที่วาดรูป วาดด้วยเมาส์ นิ้ว หรือปากกาก็ได้',
  "That's a lot of strokes! (max {max})": 'ขีดเยอะมากเลย! (สูงสุด {max} เส้น)',
  'The page is full of pencil! Try erasing or clearing a bit.': 'หน้ากระดาษเต็มไปด้วยรอยดินสอแล้ว! ลองลบหรือล้างออกบ้างนะ',

  /* ---- Creator: drawing tools ---- */
  Pencil: 'ดินสอ',
  Eraser: 'ยางลบ',
  'Colour {c}': 'สี {c}',
  'Brush size {s}': 'ขนาดแปรง {s}',
  '↶ Undo': '↶ ย้อนกลับ',
  '↷ Redo': '↷ ทำซ้ำ',
  'Undo (Ctrl+Z)': 'ย้อนกลับ (Ctrl+Z)',
  'Redo (Ctrl+Shift+Z)': 'ทำซ้ำ (Ctrl+Shift+Z)',
  'Drawing tools': 'เครื่องมือวาดรูป',
  Clear: 'ล้าง',
  'Clear the page?': 'ล้างหน้านี้เลยไหม?',
  'Rub out the whole drawing? (You can still undo.)': 'ลบรูปทั้งหมดเลยนะ? (ยังกดย้อนกลับได้)',
  'Load…': 'เปิด…',
  'No saved monsters yet — draw one and press Save!': 'ยังไม่มีมอนสเตอร์ที่บันทึกไว้เลย วาดสักตัวแล้วกดบันทึกสิ!',
  'Load a monster': 'เปิดมอนสเตอร์',
  Cancel: 'ยกเลิก',
  Load: 'โหลด',
  'Replace drawing?': 'แทนที่รูปเดิมไหม?',
  'Your unsaved drawing will be replaced.': 'รูปที่ยังไม่ได้บันทึกจะถูกแทนที่นะ',

  /* ---- Creator: monster editor ---- */
  '{stat} slider': 'แถบเลื่อน {stat}',
  'Monster name': 'ชื่อมอนสเตอร์',
  'EXP reward': 'รางวัล EXP',
  'Coin reward': 'รางวัลเหรียญ',
  'Rules mode': 'โหมดกติกา',
  'Public (balanced)': 'สาธารณะ (สมดุล)',
  'Classroom (free stats)': 'ห้องเรียน (ค่าพลังอิสระ)',
  Name: 'ชื่อ',
  Tier: 'ระดับ',
  '{tier} (budget {budget})': '{tier} (งบพลัง {budget})',
  Power: 'พลัง',
  Skill: 'สกิล',
  '{skill} ({cost} pts) — {description}': '{skill} ({cost} แต้ม) — {description}',
  Personality: 'นิสัย',
  Reward: 'รางวัล',
  Coins: 'เหรียญ',
  Max: 'สูงสุด',
  'Save Monster': 'บันทึกมอนสเตอร์',
  'Test Battle': 'ลองสู้',
  'Share With Friend': 'แชร์ให้เพื่อน',
  '{power} (no limit)': '{power} (ไม่จำกัด)',
  'Classroom monsters are practice-only: they give no EXP or coins in your notebook.': 'มอนสเตอร์ห้องเรียนมีไว้ฝึกซ้อมเท่านั้น ชนะแล้วไม่ได้ EXP หรือเหรียญในสมุดนะ',
  'Max reward for this power: {exp} EXP, {coins} coins.': 'รางวัลสูงสุดสำหรับพลังเท่านี้: {exp} EXP, {coins} เหรียญ',
  'Classroom: any stats within range, for custom class rules. Never ranked.': 'ห้องเรียน: ใส่ค่าพลังได้อิสระในช่วงที่กำหนด ใช้กับกติกาของห้อง ไม่นับอันดับ',
  'Public: stats must fit the {tier} budget so battles stay fair.': 'สาธารณะ: ค่าพลังต้องไม่เกินงบพลังระดับ{tier} เพื่อให้สู้กันอย่างยุติธรรม',
  'Draw your monster first! ✎': 'วาดมอนสเตอร์ก่อนนะ! ✎',
  'Give your monster a name!': 'ตั้งชื่อให้มอนสเตอร์ด้วยสิ!',
  'Invalid monster': 'มอนสเตอร์ไม่ถูกต้อง',
  'Drew {name}': 'วาด {name}',
  'A {tier}-tier monster with {skill}.': 'มอนสเตอร์ระดับ{tier} ที่มีสกิล {skill}',
  '{name} saved to your notebook!': 'บันทึก {name} ลงสมุดแล้ว!',
  'You need a hero to test-battle. Create one in the notebook!': 'ต้องมีฮีโร่ก่อนถึงจะลองสู้ได้ ไปสร้างในสมุดกันเลย!',

  /* ---- Creator: hero editor ---- */
  'Hero name': 'ชื่อฮีโร่',
  Class: 'อาชีพ',
  'Class (sets stats & skill)': 'อาชีพ (กำหนดค่าพลังและสกิล)',
  'Leave the page empty to keep the class doodle.': 'ถ้าไม่วาดอะไร จะใช้รูปวาดประจำอาชีพแทน',
  'Save Hero': 'บันทึกฮีโร่',
  'Create Hero': 'สร้างฮีโร่',
  '{name} joined the notebook': '{name} เข้ามาอยู่ในสมุดแล้ว',
  'Hand-drawn hero!': 'ฮีโร่วาดมือ!',
  'A {heroClass}.': '{heroClass} หนึ่งคน',
  '{name} is ready!': '{name} พร้อมลุยแล้ว!',
  'Leave without saving?': 'ออกโดยไม่บันทึกเหรอ?',
  'Your drawing has unsaved pencil marks.': 'รูปของเธอยังมีรอยดินสอที่ไม่ได้บันทึกนะ',
  Leave: 'ออก',
  Stay: 'อยู่ต่อ',

  /* ---- Drawing validation ---- */
  'Drawing has the wrong size': 'รูปวาดมีขนาดไม่ถูกต้อง',
  'Too many strokes (max {max})': 'ขีดเยอะเกินไป (สูงสุด {max} เส้น)',
  'Drawing is too detailed — try fewer scribbles': 'รูปละเอียดเกินไป ลองขีดเขียนให้น้อยลงหน่อยนะ',
  'Bad colour': 'สีไม่ถูกต้อง',
  'Bad brush size': 'ขนาดแปรงไม่ถูกต้อง',
  'Bad stroke': 'เส้นไม่ถูกต้อง',
  'Stroke outside the page': 'มีเส้นหลุดออกนอกหน้ากระดาษ',

  /* ---- How to Play ---- */
  'How to Play': 'วิธีเล่น',
  'The Game Loop': 'วงจรของเกม',
  'Draw a Monster': 'วาดมอนสเตอร์',
  'Rock Paper Scissors': 'เป่ายิ้งฉุบ',
  'Earn Rewards': 'รับรางวัล',
  Upgrade: 'อัปเกรด',
  Share: 'แชร์',
  'Repeat!': 'เล่นอีก!',
  'Just like the battles we drew in the back of our notebooks — but the doodles come alive.': 'เหมือนตอนที่เราวาดรูปสู้กันท้ายสมุดเลย แต่คราวนี้รูปวาดมีชีวิตขึ้นมาจริง ๆ!',
  'Rock · Paper · Scissors': 'ค้อน · กระดาษ · กรรไกร',
  smashes: 'ทุบ',
  snips: 'ตัด',
  wraps: 'ห่อ',
  'Same move = tie, no damage. Both sides pick at the same time; nobody can peek.': 'ออกเหมือนกัน = เสมอ ไม่มีใครโดนดาเมจ ทั้งสองฝ่ายเลือกพร้อมกัน ไม่มีใครแอบดูได้',
  'Keys: 1 / 2 / 3 or R / P / S': 'ปุ่มลัด: 1 / 2 / 3 หรือ R / P / S',
  Damage: 'ดาเมจ',
  'Combo: +{step}% per extra win in a row (max +{cap}%).': 'คอมโบ: ชนะติดกันแต่ละครั้งเพิ่ม +{step}% (สูงสุด +{cap}%)',
  'Critical hit: LUCK% chance (max {chance}%) for +{bonus}%.': 'คริติคอล: มีโอกาสเท่ากับ LUCK% (สูงสุด {chance}%) ทำดาเมจเพิ่ม +{bonus}%',
  'After {rounds} rounds the fighter with more HP (in %) wins.': 'ครบ {rounds} รอบแล้ว ฝ่ายที่เหลือ HP (คิดเป็น %) มากกว่าชนะ',
  Skills: 'สกิล',
  'Monster Personalities': 'นิสัยมอนสเตอร์',
  'Monsters decide before you do, based only on earlier rounds.': 'มอนสเตอร์ตัดสินใจก่อนเธอ โดยดูจากรอบก่อน ๆ เท่านั้น',
  'Fair Play': 'เล่นอย่างยุติธรรม',
  'Public monsters must fit a stat budget: HP ×{hp}, ATK ×{atk}, DEF ×{def}, LUCK ×{luck} + skill cost.': 'มอนสเตอร์สาธารณะต้องไม่เกินงบพลัง: HP ×{hp}, ATK ×{atk}, DEF ×{def}, LUCK ×{luck} + ค่าสกิล',
  'Tiers: {list}.': 'ระดับ: {list}',
  'Online ranked battles scale heroes into a {budget}-point arena budget. The server decides every result.': 'การสู้จัดอันดับออนไลน์จะปรับฮีโร่ให้อยู่ในงบพลังสนาม {budget} แต้ม และเซิร์ฟเวอร์เป็นคนตัดสินผลทุกครั้ง',
  'Classroom rooms: the room owner sets custom rules and free stats — fun, but never ranked.': 'ห้องเรียน: เจ้าของห้องตั้งกติกาและค่าพลังได้เอง สนุกดี แต่ไม่นับอันดับ',
  'The Notebook': 'สมุด',
  'Hero profile, monster collection, equipment, quests, memories, friends and settings all live on its pages. Everything saves automatically.': 'โปรไฟล์ฮีโร่ คอลเลกชันมอนสเตอร์ อุปกรณ์ เควสต์ ความทรงจำ เพื่อน และการตั้งค่า อยู่ในหน้าสมุดทั้งหมด ทุกอย่างบันทึกให้อัตโนมัติ',
  'F3 shows the debug overlay (FPS, frame time, objects).': 'กด F3 เพื่อดูข้อมูลดีบัก (FPS, เวลาต่อเฟรม, จำนวนออบเจกต์)',
};
